export default __webpack_public_path__ + "static/media/IBMPlexSans-BoldItalic.1d32de20.woff";